import React from "react";
import { CheckIcon, GiftIcon, InfoIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { bonuses } from "../../data/content";
export function Bonuses() {
  return <section className="bg-cream px-4 py-16 sm:py-24" data-id="element-104" data-mp="1clfuv3vje3px">
      <SectionHeading kicker="And there’s more!" title="Your 5 Exclusive Bonus Packs" data-id="element-105" data-mp="18kds4d2ev9j7" />

      <div className="mx-auto mt-12 max-w-6xl space-y-16 sm:space-y-24" data-id="element-106" data-mp="25adbz3o0huh3">
        {bonuses.map((b, i) => <article key={b.title} className="lg:grid lg:grid-cols-2 lg:items-center lg:gap-14" data-id="element-107" data-mp="20ail3048l4w1" data-mpi={i}>
            <div className={i % 2 === 1 ? "lg:order-2" : ""} data-id="element-108" data-mp="1w8nilsakklgo">
              <img src={b.image} alt={`Bonus #${i + 1}: ${b.title}`} className="-mx-4 w-[calc(100%+2rem)] max-w-none sm:mx-0 sm:w-full" loading="lazy" data-id="element-109" data-mp="1wb00y6k8oxu9" />
            </div>

            <div className="mt-6 lg:mt-0" data-id="element-110" data-mp="ftvrrjt2nm9h">
              <div className="flex flex-wrap items-center gap-3" data-id="element-111" data-mp="fx0454goxob8">
                <span className="inline-flex items-center gap-2 rounded-full bg-navy px-4 py-2 font-display text-lg font-bold uppercase text-white" data-id="element-112" data-mp="1euydu4nkgdcb">
                  <GiftIcon className="h-5 w-5 text-sun" aria-hidden="true" data-id="element-113" data-mp="15syw1a4q958b" />
                  Bonus #{i + 1}
                </span>
                <span className="rounded-full px-3 py-1.5 text-sm font-extrabold text-navy" style={{
              backgroundColor: b.color
            }} data-id="element-114" data-mp="1ara4bgfdj7of">
                  Illustrative Reference Value: <span className="line-through" data-id="element-115" data-mp="10tvq7ngxauza">$12</span>
                </span>
              </div>
              <h3 className="mt-4 font-display text-[1.9rem] font-bold leading-[1.1] text-navy sm:text-4xl" data-id="element-116" data-mp="n2h7ziuuaxta">{b.title}</h3>
              <p className="mt-3 text-lg leading-relaxed text-ink-soft" data-id="element-117" data-mp="r3knu5cw0tui">{b.lead}</p>
              <p className="mt-5 text-sm font-extrabold uppercase tracking-wide text-navy" data-id="element-118" data-mp="d4ky0udn28wr">Includes:</p>
              <ul className="mt-3 space-y-2.5" data-id="element-119" data-mp="i34kcvw59mpn">
                {b.includes.map(item => <li key={item} className="flex items-start gap-3 text-lg font-bold text-navy" data-id="element-120" data-mp="2jsbiwqdoyc77">
                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-teal text-white" data-id="element-121" data-mp="2f23j50dthzx3">
                      <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-122" data-mp="2b1b944x4fqzr" />
                    </span>
                    {item}
                  </li>)}
              </ul>
              <p className="mt-5 flex items-start gap-2 text-sm leading-snug text-ink-soft" data-id="element-123" data-mp="32qeejo0qv7dz">
                <InfoIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-124" data-mp="2yqvtms8xawb5" />
                {b.note}
              </p>
            </div>
          </article>)}
      </div>

      <CtaButton label="Yes! I want the 5 bonus packs" className="mt-14" data-id="element-125" data-mp="2os6bcyd479ud" />
    </section>;
}